import { useAuthStore } from 'cloak-auth/src/Client/stores';

import { customSuccessToast, deviceUpdatedSuccess } from '../toasts';
import { refreshScan } from './renkiInvoke';

export const autoScan = async (tauri: boolean, installationID: string) => {
    if (!tauri || !installationID) {
        return;
    }

    try {
        const cloak = useAuthStore.getState().keyCloak;
        if (!cloak?.token) {
            throw new Error('Not authenticated');
        }
        await cloak.updateToken(5);

        const refreshDone = await refreshScan(cloak.token);
        if (refreshDone) {
            customSuccessToast(deviceUpdatedSuccess);
        }
    } catch (error) {
        console.error('Error in autoScan:', error);
    }
};
